<div [attr.role]="alertRole()" class="alert alert-{{ alertType() }} reset-form-success alert-dismissible widget-alert-box">
  @if (dismissableButton()) {
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  }
  @if (title()) {
    <span class="alert-title">{{ title() }} <br>
    <hr/></span>
  }
  @if (messages(); as messages) {
    <ul class="ps-3">
      @for (message of messages; track message) {
        <li>
          <span [innerHtml]="message | trustHtml: 'html'"></span>
        </li>
      }
    </ul>
  } @else {
    <span [innerHtml]="text() | trustHtml: 'html'"></span>
  }
  <ng-content />
</div>
